module.exports = __webpack_public_path__ + "img/DSC04162-3.700167da.jpg";